module.exports = __webpack_public_path__ + "img/bell-school-slash.c1e1ce74.svg";